import { ICurrencyStore } from './index'

export default {} as ICurrencyStore
